// Background pictures for the call: ready-made ones shipped with the app, plus saved ones (own or company).
import { fetchBackgroundBytes } from '@/api/morningMeeting';

export const PRESET_GROUPS = [
  { label: 'Gardens & landscapes', items: [['garden-arbor', 'Garden arbor'], ['flower-garden', 'Flower garden'], ['park-path', 'Park path'], ['rolling-hills', 'Rolling hills']] },
  { label: 'City & outdoors', items: [['city-harbor', 'City harbor'], ['city-towers', 'City towers'], ['mountain-lake', 'Mountain lake'], ['forest-lake', 'Forest lake']] },
].map((g) => ({ ...g, items: g.items.map(([slug, name]) => ({ id: `preset:${slug}`, name })) }));

// Absolute so it also loads inside the pop-out window's document.
export const presetSrc = (id, thumb = false) =>
  `${window.location.origin}${process.env.PUBLIC_URL || ''}/meeting-backgrounds/${id.slice(7)}${thumb ? '-thumb' : ''}.jpg`;

const cache = new Map();
async function fetchPreset(id) {
  const r = await fetch(presetSrc(id));
  if (!r.ok) throw new Error('missing');
  return r.arrayBuffer();
}

// The picture's bytes for the call's video processor (a fresh copy each time: the processor may take ownership).
export async function loadBackground(bg) {
  if (bg.bytes) return bg.bytes.slice(0);
  if (!cache.has(bg.id)) {
    const p = bg.id.startsWith('preset:') ? fetchPreset(bg.id) : fetchBackgroundBytes(bg.id);
    cache.set(bg.id, p.catch((e) => { cache.delete(bg.id); throw e; }));
  }
  return (await cache.get(bg.id)).slice(0);
}
